// removed by extract-text-webpack-plugin
module.exports = {"inputTextCenter":"cn_co","inlineInputGroupButton":"cn_cp","inlineInputGroupAddon":"cn_cq","inputList":"cn_cr","label":"cn_bj","checkbox":"cn_cs","disabled":"cn_ct","responsiveTextarea":"cn_cu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/form/form.module.scss
// module id = 42
// module chunks = 0